import { memo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createAlert, setCreateAlertStatus } from 'redux/actions';
import { getEnglishDateWithTime } from 'utils/helpers';
import { NewsForm } from 'components/widgets';
import { LeftContainer } from 'components/styled-components';
import {
  FHCard,
  FHCardHeader,
  FHCardContent,
} from 'components/styled-components';

import { ALERT_PROTO_TYPES } from 'utils/constants';

const News = () => {
  const dispatch = useDispatch();
  const createAlertStatus = useSelector((state) => state.notifications.createAlertStatus);

  const handleCreate = async (data) => {
    dispatch(createAlert(ALERT_PROTO_TYPES.news, data));
  };

  useEffect(() => {
    dispatch(setCreateAlertStatus("idle"));
  }, [createAlertStatus, dispatch])

  return (
    <LeftContainer maxWidth="md">
      <FHCard>
        <FHCardHeader
          title="Create News Alert"
          subheader={getEnglishDateWithTime(new Date())}
        />
        <FHCardContent>
          <NewsForm onSubmit={handleCreate} isSuccess={createAlertStatus === "success"} />
        </FHCardContent>
      </FHCard>
    </LeftContainer>
  );
};

export default memo(News);
